<template>
	<div class="order-summary"
	     :class="[advanced.cssClasses, responsiveClasses,
	     {'__collapsable':collapsable},{'__open':isOpen},{'__images':showImages}, `el-${details.id}`]"
	     :id="advanced.cssId" :style="style">
		<v-style>
			{{cssStyle}}
		</v-style>
		<div class="os-collapse-header" v-if="collapsable" :style="labelsStyle">
			<div class="__title">
				<inline-svg class="__icon" :src="require('@/assets/img/cart-outline.svg')"/>
				<span v-text="localData.showSummary" class="__show-summary"  />
				<span v-text="localData.hideSummary" class="__hide-summary"  />
				<inline-svg class="__arrow" :src="require('@/assets/img/arrow-bottom-cl.svg')"/>
			</div>
			<span class="__total">
				$0.00
			</span>
		</div>

		<div class="os-inner-container" :style="{'height':(collapsable && !isOpen)?'0px':null}">
		<div class="os-content" :style="contentStyle">
			<div class="os-header" v-if="showHeader">
				<span :style="labelsStyle">{{ localData.product }}</span>
				<span :style="labelsStyle">{{ localData.price }}</span>
			</div>
			<div class="os-items" :style="productsStyle">
			</div>

			<div class="os-discount-box" v-if="allowDiscountCodes">
				<div class="os-row">
					<input class="__input" :placeholder="localData.discountCode" />
					<div class="btn-container">
						<a class="btn __apply">
							<span class="btn-headline">{{ localData.apply }}</span>
					  </a>
					</div>
				</div>
				<div class="__discount-error hidden"></div>
				<div class="os-row os-applied-discounts">
					<div class="__current-discount hidden">
						<inline-svg class="__icon" :src="require('@/assets/img/tag-multiple.svg')" />
						<span class="__value"></span>
						<span class="__remove">
							<inline-svg :src="require('@/assets/img/close.svg')" />
						</span>
					</div>
				</div>
			</div>
			<div class="os-subtotal hidden" :style="labelsStyle">
				<div class="os-row __subtotal-row">
					<div class="os-name">
	          <span >
	              {{ localData.subtotal }}
	          </span>
					</div>

					<div class="os-price">${{ priceSum }}</div>
				</div>

				<div class="os-row __discount-row hidden">
					<div class="os-name">
	          <span >
	              {{ localData.discount }}
	          </span>
						<div class="__applied-discount">
							<inline-svg class="__icon" :src="require('@/assets/img/tag-multiple.svg')" />
							<span class="__value"></span>
						</div>
					</div>

					<div class="os-price">- ${{ 0.00 }}</div>
				</div>

				<div class="os-row __tax-row hidden">
					<div class="os-name">
	          <span >
	              {{ localData.tax }}
	          </span>
						<div class="__applied-tax">
							<span class="__value"></span>
						</div>
					</div>

					<div class="os-price">- ${{ 0.00 }}</div>
				</div>

			</div>

			<div class="os-total os-row" :style="labelsStyle" v-if="showTotal">
				<div class="os-name">
					{{ localData.total }}
				</div>

				<div class="os-price">${{ priceSum }}</div>
			</div>
		</div>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex"
import {borderProps, boxShadow, textDecoration, getPadding, fontProps} from "@/modules/page-editor/src/utils/props";

export default {
	name: 'EmailOrderSummary',
	props: ['details'],
	data: function () {
		return {
			// localData: {},
			products: [
			],
			defContent: {
				total:'Total',
				product: 'Product',
				price: 'Price',
				subtotal: 'Subtotal',
				discount: 'Discount',
				tax: 'Tax',
				discountCode:'Discount code',
				apply:'Apply',
				showSummary:'Show order summary',
				hideSummary:'Hide order summary'
			},
		}
	},
	computed: {
		content() {
			return this.details
		},
		basic() {
			return this.content.attributes.basic
		},
		advanced() {
			return this.content.attributes.advanced
		},
		responsive() {
			return this.details.responsive
		},
		props() {
			return this.basic.props || {};
		},
		showHeader(){
			// legacy property, is enabled by default.
			return !this.basic.props || this.props.showHeader
		},
		showTotal(){
			// legacy property, is enabled by default.
			return !this.basic.props || this.props.showTotal
		},
		allowDiscountCodes(){
			return this.props.allowDiscountCodes
		},
		showImages(){
			return this.props.showImages
		},
		collapsable() {
			return this.props.collapsable;
		},
		isOpen() {
			return this.props.isOpen;
		},
		localData() {
			let c = this.content.content
			if (c) {
				Object.keys(this.defContent).forEach(x => {
					if (c[x]==undefined) {
						c[x] = this.defContent[x] || '';
					}
				})
				return c;
			}
			return this.defContent
		},
		cssStyle() {
			let c = this.basic.separatorColor || 'rgba(175,175,175,0.34)';
			let bg = this.basic.headerBgColor || '#fafafa';
			let s = `.el-${this.details.id} .os-collapse-header, .el-${this.details.id} .os-discount-box,
			.el-${this.details.id} .os-subtotal, .el-${this.details.id} .os-total {
			  border-color: ${c} !important;
			}`
			if (bg) {
				s += `.el-${this.details.id} .os-collapse-header {
				  background: ${bg} !important;
				}`
			}
			return s
		},
		responsiveClasses() {
			let c = '';
			if (!this.responsive) return '';
			if (!this.responsive.desktop) c = 'no-desktop';
			if (!this.responsive.mobile) c += ' no-mobile';
			if (!this.responsive.tablets) c += ' no-tablet';
			return c;
		},
		priceSum() {
			let summ = 0;
			for (let index = 0; index < this.products.length; index++) {
				const thisNumber = parseInt(this.products[index].price) * this.products[index].pcs;

				summ += thisNumber;
			}
			return summ;
		},
		labelsStyle() {
			return {
				...fontProps(this.basic.font),
			};
		},
		productsStyle() {
			return {
				...fontProps(this.basic.font2),
			};
		},
		style() {
			return {
				...borderProps(this.basic.border),
				margin: getPadding(this.basic.margin),
				// backgroundColor: this.basic.backgroundColor,
				boxShadow: boxShadow(this.basic.shadows),
			};
		},
		contentStyle() {
			return {
				// ...borderProps(this.basic.border),
				padding: getPadding(this.advanced.padding),
				backgroundColor: this.basic.backgroundColor,
			};
		},
	},
	methods: {},
	created() {
		// this.localData = this.content.content ? this.content.content : this.defContent;
	}
}
</script>
